import {ReactNode} from 'react';
import {ErpUiRouterContext, ErpUiRouterContextModel} from './erp-react-router-context';

interface Props {
  children: ReactNode;
  context: ErpUiRouterContextModel;
}

export function ErpReactUiRouterContextWrapper(props: Props) {
  return <ErpUiRouterContext.Provider value={{context: props.context}}>
    {props.children}
  </ErpUiRouterContext.Provider>;
}
